import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/LearnerDashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Videos from "../components/Videos";
import { allYouTubeVideos } from "../Services/AllServices";
import LearnerProfileHeader from "../components/LearnerProfileHeader";

import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import tutorials from "../images/tutorials.png";
import history from "../images/history.png";

const LearnerDashboard = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // Store search query
  const [videoData, setVideoData] = useState([]);
  const [showUploadForm, setShowUploadForm] = useState(false);
  // Store dynamic video data

  const navigate = useNavigate(); // Initialize useNavigate

  // Fetch dynamic video data from the API
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        await allYouTubeVideos((response) => {
          if (Array.isArray(response.data)) {
            setVideoData(response.data);
          }
        });
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos(); // Trigger the fetch on component mount
  }, []);

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const learnerMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
    { icon: history, label: "History", key: "history", disabled: true },
  ];

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/learner/feedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/learner"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  const filteredVideos = videoData.filter((video) =>
    video.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={(query) => setSearchQuery(query)}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={learnerMenuItems}
          resetSearch={resetSearch}
        />

        <div className="content">
          <LearnerProfileHeader
            showUploadForm={showUploadForm}
            setShowUploadForm={setShowUploadForm}
          />
          <Videos videoData={filteredVideos} />
        </div>
      </main>
    </div>
  );
};

export default LearnerDashboard;
